<template>
  <div class="main-content">
    <b-container class="mt-4">
      <b-row>
        <b-col>
          <img src="@/assets/logo.svg" fluid class="float-left mr-3" height="100" />
          <h1 class="mt-3">Cloud Workplace Management</h1>
        </b-col>
      </b-row>

      <b-row class="mt-5">
        <b-col cols lg="8" class="lead">
          <p class="lead">Con CWM hai la tranquillità di avere una squadra di tecnici altamente qualificati,
            in grado di gestire i dispositivi digitali della tua azienda e risolvere tutte le problematiche:</p>
          <ul>
            <li>Prima configurazione</li>
            <li>Assistenza in caso di malfunzionamenti software o hardware</li>
            <li>Fleet management</li>
          </ul>

          <p class="mb-2">Disegna il servizio a misura delle tue esigenze!</p>

          <hr>

          <p class="mt-2">
            <b-btn variant="danger" size="lg" :to="'download'">
              <i class="fas fa-cloud-download-alt mr-2"></i>
              Scarica l'applicazione
            </b-btn>
          </p>

        </b-col>
        <b-col>
          <b-jumbotron>
            <template slot="lead">
              Se sei già un utente <strong>CWM</strong>, accedi all'area riservata per controllare e gestire il tuo
              servizio.
            </template>
            <hr class="my-4">
            <p>
              Accedi con le credenziali che hai ricevuto tramite mail o SMS. <a href="/#/recover">Non ricordi le tue
              credenziali?</a>
            </p>
            <b-link :to="'area-riservata/piani'" v-if="isLogged" class="btn btn-lg btn-primary">
              <i class="fas fa-sign-in-alt mr-2"></i>
              Accedi all'Area Riservata
            </b-link>
            <b-link :to="'login'" v-else class="btn btn-lg btn-primary">Accedi all'Area Riservata</b-link>
          </b-jumbotron>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'Index',
    computed: {
      ...mapGetters([
        'isLogged',
      ]),
    },
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Index.vue